export default __webpack_public_path__ + "static/media/tfp-bottle@2x.8d06d81a.png";